var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIDuplicate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71875 16H3.75C2.37146 16 1.25 14.8785 1.25 13.5V5.03125C1.25 3.65271 2.37146 2.53125 3.75 2.53125H9.71875C11.0973 2.53125 12.2188 3.65271 12.2188 5.03125V13.5C12.2188 14.8785 11.0973 16 9.71875 16ZM3.75 3.78125C3.06079 3.78125 2.5 4.34204 2.5 5.03125V13.5C2.5 14.1892 3.06079 14.75 3.75 14.75H9.71875C10.408 14.75 10.9688 14.1892 10.9688 13.5V5.03125C10.9688 4.34204 10.408 3.78125 9.71875 3.78125H3.75ZM14.7188 11.9375V2.5C14.7188 1.12146 13.5973 0 12.2188 0H5.28125C4.93604 0 4.65625 0.279785 4.65625 0.625C4.65625 0.970215 4.93604 1.25 5.28125 1.25H12.2188C12.908 1.25 13.4688 1.81079 13.4688 2.5V11.9375C13.4688 12.2827 13.7485 12.5625 14.0938 12.5625C14.439 12.5625 14.7188 12.2827 14.7188 11.9375Z",
    fill: "#00427D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDuplicate);
export default __webpack_public_path__ + "static/media/i_duplicate.0720f3497d71f1b972386b8a21475952.svg";
export { ForwardRef as ReactComponent };